import React from "react";

export const PdfIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5236 2.78143L11.5314 0.753007C11.0613 0.274385 10.4002 0 9.71687 0H3.33173C2.48184 0 1.79057 0.667274 1.79057 1.48765V4.47531H1.54117C0.691277 4.47531 0 5.14258 0 5.96296V11.5185C0 12.3389 0.691277 13.0062 1.54117 13.0062H1.79057V14.5123C1.79057 15.3327 2.48184 16 3.33173 16H12.6683C13.5182 16 14.2094 15.3327 14.2094 14.5123V13.0062H14.4588C15.3087 13.0062 16 12.3389 16 11.5185V5.96296C16 5.14258 15.3087 4.47531 14.4588 4.47531H14.2094V4.44201C14.2094 3.8216 13.9658 3.23169 13.5236 2.78143ZM2.95444 1.48765C2.95444 1.28692 3.12378 1.12346 3.33173 1.12346H9.71687C10.0819 1.12346 10.4356 1.27025 10.6868 1.52597L12.679 3.5544C12.9155 3.79519 13.0456 4.11022 13.0456 4.44201V4.47531H2.95444V1.48765ZM14.8361 11.5185C14.8361 11.7192 14.6668 11.8827 14.4588 11.8827H1.54117C1.33322 11.8827 1.16387 11.7192 1.16387 11.5185V5.96296C1.16387 5.76223 1.33322 5.59876 1.54117 5.59876H14.4588C14.6668 5.59876 14.8361 5.76223 14.8361 5.96296V11.5185ZM13.0456 14.5123C13.0456 14.7131 12.8762 14.8765 12.6683 14.8765H3.33173C3.12378 14.8765 2.95444 14.7131 2.95444 14.5123V13.0062H13.0456V14.5123Z"
        fill="#562B85"
      />
      <path
        d="M4.34366 6.83203H3.43121C3.31662 6.83203 3.20672 6.87577 3.1258 6.95356C3.04488 7.03135 2.99963 7.13684 3 7.24672L3.00636 10.3868C3.00636 10.615 3.19942 10.8001 3.43756 10.8001C3.6757 10.8001 3.86876 10.615 3.86876 10.3868V9.43335C4.04507 9.4325 4.23342 9.43175 4.34366 9.43175C5.10131 9.43175 5.71773 8.84863 5.71773 8.13189C5.71773 7.41515 5.10131 6.83203 4.34366 6.83203V6.83203ZM4.34366 8.60503C4.23244 8.60503 4.0434 8.60577 3.86641 8.60665C3.86549 8.43067 3.86468 8.24116 3.86468 8.13189C3.86468 8.03839 3.86419 7.8427 3.86367 7.65876H4.34363C4.62098 7.65876 4.8553 7.87541 4.8553 8.13189C4.8553 8.38837 4.62101 8.60503 4.34366 8.60503V8.60503Z"
        fill="#562B85"
      />
      <path
        d="M8.01153 6.83203H7.11089C6.99639 6.83203 6.88658 6.87568 6.80569 6.95337C6.72479 7.03105 6.67946 7.1364 6.67969 7.24617C6.67969 7.24619 6.6861 10.2843 6.68613 10.2953C6.68656 10.4049 6.73238 10.5099 6.81356 10.5872C6.89437 10.6641 7.00355 10.7072 7.11733 10.7072H7.11897C7.14619 10.7071 7.7886 10.7047 8.04543 10.7004C9.01977 10.6841 9.72695 9.87206 9.72695 8.7696C9.72692 7.6107 9.03757 6.83203 8.01153 6.83203V6.83203ZM8.03036 9.87383C7.91868 9.8757 7.72654 9.87722 7.5471 9.87832C7.54589 9.51927 7.54353 8.03189 7.54287 7.65876H8.01153C8.80302 7.65876 8.86451 8.50902 8.86451 8.76963C8.86451 9.31229 8.60659 9.86418 8.03036 9.87383Z"
        fill="#562B85"
      />
      <path
        d="M12.569 7.62751C12.8071 7.62751 13.0002 7.44243 13.0002 7.21414C13.0002 6.98586 12.8071 6.80078 12.569 6.80078H11.2505C11.0124 6.80078 10.8193 6.98586 10.8193 7.21414V10.3325C10.8193 10.5608 11.0124 10.7459 11.2505 10.7459C11.4887 10.7459 11.6817 10.5608 11.6817 10.3325V9.15717H12.4642C12.7024 9.15717 12.8954 8.97209 12.8954 8.74381C12.8954 8.51552 12.7024 8.33044 12.4642 8.33044H11.6817V7.62751H12.569Z"
        fill="#562B85"
      />
    </svg>
  );
};

export const RetryIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3779 5.37881H11.3773C11.2958 5.37888 11.2151 5.395 11.1398 5.42626C11.0646 5.45751 10.9962 5.50328 10.9386 5.56097C10.881 5.61865 10.8354 5.68711 10.8042 5.76243C10.7731 5.83776 10.7571 5.91848 10.7572 5.99999C10.7564 6.87009 10.5171 7.72334 10.0654 8.46698C9.61364 9.21062 8.96669 9.81621 8.19487 10.2179C7.42304 10.6196 6.55587 10.8021 5.68761 10.7454C4.81935 10.6888 3.98323 10.3953 3.27011 9.89673C1.12118 8.39201 0.597026 5.41949 2.10175 3.27052C3.60647 1.12156 6.57901 0.597359 8.72795 2.10213C9.05307 2.32918 9.34853 2.59596 9.60749 2.89628H7.86093C7.69633 2.89628 7.53847 2.96167 7.42208 3.07806C7.30569 3.19445 7.2403 3.35231 7.2403 3.51692C7.2403 3.68152 7.30569 3.83938 7.42208 3.95577C7.53847 4.07216 7.69633 4.13755 7.86093 4.13755H10.7572C10.9218 4.13755 11.0797 4.07216 11.1961 3.95577C11.3125 3.83938 11.3778 3.68152 11.3778 3.51692V0.620632C11.3778 0.45603 11.3125 0.29817 11.1961 0.181779C11.0797 0.0653879 10.9218 0 10.7572 0C10.5926 0 10.4348 0.0653879 10.3184 0.181779C10.202 0.29817 10.1366 0.45603 10.1366 0.620632V1.65417C9.91878 1.44752 9.68592 1.25736 9.43992 1.08525C8.79459 0.633391 8.06658 0.313061 7.29745 0.142553C6.52832 -0.0279556 5.73313 -0.0453029 4.9573 0.0915011C4.18147 0.228305 3.44018 0.516581 2.77575 0.939871C2.11133 1.36316 1.53678 1.91317 1.08492 2.5585C0.172344 3.86181 -0.185119 5.47426 0.0911688 7.04113C0.367457 8.60799 1.25486 10.0009 2.55817 10.9135C3.56161 11.6203 4.75894 11.9998 5.98631 12C6.33982 11.9998 6.69265 11.9688 7.04076 11.9073C8.42979 11.6623 9.68809 10.9357 10.5947 9.85522C11.5014 8.77473 11.9984 7.40938 11.9985 5.9989C11.9983 5.8344 11.9329 5.67668 11.8165 5.56041C11.7001 5.44414 11.5424 5.37882 11.3779 5.37881Z"
        fill="#FF1640"
      />
    </svg>
  );
};

export const FolderIcon = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0286 2.69619H8.96455C8.75898 2.69619 8.5582 2.61178 8.41955 2.46831L6.83946 0.803815C6.45964 0.425221 5.93999 0.227472 5.41368 0.230503H1.97137C0.884405 0.230472 0 1.11488 0 2.20181V11.7994C0 12.8864 0.884405 13.7708 1.97137 13.7708H14.0358H14.0377C15.124 13.7659 16.0048 12.8773 16 11.7934V4.66753C16 3.58056 15.1156 2.69619 14.0286 2.69619ZM14.7943 11.7958C14.7961 12.2178 14.4543 12.5632 14.0347 12.565H1.97137C1.54937 12.565 1.20575 12.2214 1.20575 11.7994V2.20181C1.20575 1.77981 1.54937 1.43619 1.97137 1.43556H5.42936C5.43599 1.43556 5.44261 1.43556 5.44927 1.43556C5.65061 1.43556 5.84596 1.51575 5.97736 1.64597L7.54902 3.30262C7.91795 3.68362 8.43402 3.90187 8.96455 3.90187H14.0286C14.4506 3.90187 14.7942 4.2455 14.7942 4.66749V11.7958H14.7943Z"
        fill="#562B85"
      />
    </svg>
  );
};

export const AttachmentIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.39071 9.19077L4.44756 8.24762L6.09731 6.59787C6.19016 6.50502 6.26382 6.39478 6.31408 6.27345C6.36433 6.15213 6.3902 6.02209 6.3902 5.89077C6.3902 5.75945 6.36433 5.62941 6.31408 5.50809C6.26382 5.38676 6.19016 5.27652 6.09731 5.18366C6.00445 5.0908 5.89421 5.01714 5.77288 4.96689C5.65156 4.91663 5.52152 4.89077 5.3902 4.89077C5.25888 4.89077 5.12884 4.91663 5.00752 4.96689C4.88619 5.01714 4.77595 5.0908 4.68309 5.18366L2.32624 7.54051C1.88863 7.97812 1.64279 8.57164 1.64279 9.19051C1.64279 9.80938 1.88863 10.4029 2.32624 10.8405C2.76385 11.2781 3.35737 11.524 3.97624 11.524C4.59511 11.524 5.18864 11.2781 5.62624 10.8405L10.3399 6.12681C10.5567 5.91019 10.7287 5.65299 10.846 5.36989C10.9633 5.0868 11.0238 4.78337 11.0238 4.47692C11.0239 4.17047 10.9635 3.86702 10.8463 3.58389C10.729 3.30076 10.5572 3.0435 10.3405 2.82681L10.1044 2.59077C9.72934 2.21569 9.22063 2.00498 8.6902 2.00498C8.15977 2.00498 7.65106 2.21569 7.27599 2.59077L6.33335 1.64813C6.95843 1.02305 7.80621 0.671888 8.6902 0.671888C9.57419 0.671888 10.422 1.02305 11.0471 1.64813L11.2826 1.88366C11.9703 2.57134 12.3566 3.50403 12.3566 4.47655C12.3566 5.44908 11.9703 6.38177 11.2826 7.06945L6.56837 11.7837C6.22963 12.132 5.82504 12.4096 5.3781 12.6002C4.93117 12.7908 4.4508 12.8907 3.96492 12.8941C3.47904 12.8975 2.99734 12.8043 2.5478 12.6198C2.09826 12.4354 1.68986 12.1635 1.34631 11.8199C1.00277 11.4763 0.730944 11.0678 0.546628 10.6183C0.362312 10.1687 0.269183 9.68698 0.272652 9.2011C0.276121 8.71522 0.376121 8.23488 0.566838 7.78798C0.757556 7.34108 1.03519 6.93655 1.3836 6.59788L3.74045 4.24102C3.95714 4.02434 4.21437 3.85246 4.49748 3.73519C4.78059 3.61793 5.08402 3.55757 5.39046 3.55757C5.69689 3.55757 6.00032 3.61793 6.28343 3.73519C6.56654 3.85246 6.82378 4.02434 7.04046 4.24102C7.25714 4.45771 7.42902 4.71494 7.54629 4.99805C7.66355 5.28116 7.72391 5.58459 7.72391 5.89103C7.72391 6.19746 7.66355 6.50089 7.54629 6.784C7.42902 7.06711 7.25714 7.32435 7.04046 7.54103L5.39071 9.19077Z"
        fill="#B0B7C3"
      />
    </svg>
  );
};

export const Folder = () => {
  return (
    <svg
      width="220"
      height="186"
      // viewBox="0 0 320 286"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85 189.995H215C220.523 189.995 225 185.518 225 179.995V93.355C225 87.8322 220.523 83.355 215 83.355H151.005C148.085 83.355 145.394 81.7765 143.969 79.2283C142.544 76.6801 139.853 75.1016 136.933 75.1016H85C79.4772 75.1016 75 79.5787 75 85.1016V179.995C75 185.518 79.4772 189.995 85 189.995Z"
        fill="#FFC93E"
      />
      <rect
        x="81.3857"
        y="87.5391"
        width="100.043"
        height="36.8087"
        // rx="10"
        fill="black"
        fill-opacity="0.05"
      />
      <rect
        x="82.8008"
        y="89.3105"
        width="100.043"
        height="36.8087"
        // width="134.043"
        // height="96.8087"
        // rx="10"
        fill="white"
      />
      <path
        d="M215 188.958H85C79.4772 188.958 75 184.481 75 178.958V114.719C75 109.196 79.4771 104.719 85 104.719H148.286C151.756 104.719 154.899 102.672 156.302 99.4981C157.705 96.3245 160.848 94.2773 164.317 94.2773H215C220.523 94.2773 225 98.7545 225 104.277V178.958C225 184.481 220.523 188.958 215 188.958Z"
        fill="black"
        fill-opacity="0.06"
      />
      <path
        d="M215 189.993H85C79.4772 189.993 75 185.516 75 179.993V115.754C75 110.231 79.4771 105.754 85 105.754H148.286C151.756 105.754 154.899 103.707 156.302 100.533C157.705 97.3596 160.848 95.3125 164.317 95.3125H215C220.523 95.3125 225 99.7896 225 105.312V179.993C225 185.516 220.523 189.993 215 189.993Z"
        fill="#FFAA2B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M135.414 190.184H214.828C220.351 190.184 224.828 185.707 224.828 180.184V139.789C199.593 166.491 165.03 181.99 135.414 190.184Z"
        fill="#FFA114"
      />
    </svg>
  );
};
